.dialog {
  display: flex;
  flex-direction: column;
  gap: var(--space-l);
}

.about {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.body {
  max-width: var(--measure-text);

  font-size: var(--size-300);
  line-height: var(--leading-normal);

  color: var(--text-muted);
}

/* Where the question sits in the catalogue: property first, then its topic. */
.place {
  font-size: var(--size-200);

  color: var(--text-muted);
}

.place strong {
  font-weight: var(--weight-medium);

  color: var(--text);
}

.dot {
  margin-inline: var(--space-xs);

  color: var(--text-faint);
}

/*
 * The two answers side by side, the way the table above put their numbers.
 * Each side is a column with its own padding, so the framed one can take a
 * fill without the other shifting.
 */
.sides {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-m);
}

.side {
  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  min-width: 0;
  padding: var(--space-m);

  border: 1px solid transparent;
  border-radius: var(--radius-s);
}

.side:focus {
  outline: none;
}

.side:focus-visible {
  box-shadow: var(--ring);
}

/* The side the reader asked about, framed so the eye lands where the click was. */
.focused {
  background-color: var(--surface-sunken);

  border-color: var(--border);
}

.sideA {
  --side: var(--compare-a);
}

.sideB {
  --side: var(--compare-b);
}

.name {
  display: flex;
  align-items: center;
  gap: var(--space-xs);

  font-size: var(--size-300);
  font-weight: var(--weight-medium);
  line-height: var(--leading-tight);

  color: var(--text);
}

.swatch {
  flex: none;

  width: 0.5rem;
  height: 0.5rem;

  background-color: var(--side);

  border-radius: var(--radius-pill);
}

.sideB .swatch {
  border-radius: var(--radius-xs);
}

.value {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-xs) var(--space-s);
}

.number {
  font-size: var(--size-600);
  font-weight: var(--weight-strong);
  font-variant-numeric: tabular-nums;
  line-height: 1;

  color: var(--text);
}

.given {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2xs);

  font-size: var(--size-200);

  color: var(--text-muted);
}

.givenLabel {
  margin-inline-end: var(--space-2xs);
}

.option {
  padding: var(--space-3xs) var(--space-xs);

  color: var(--text);
  background-color: var(--surface-raised);

  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
}

.origin {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-xs);

  font-size: var(--size-200);

  color: var(--text-muted);
}

.author {
  color: var(--text-muted);
}

.reasoning {
  display: flex;
  flex-direction: column;
  gap: var(--space-2xs);

  padding-top: var(--space-s);

  border-top: 1px solid var(--border);
}

.label {
  font-size: var(--size-100);
  font-weight: var(--weight-medium);
  letter-spacing: 0.04em;
  text-transform: uppercase;

  color: var(--text-muted);
}

/* The author's own words, with their line breaks; never a summary of them. */
.text {
  font-size: var(--size-300);
  line-height: var(--leading-normal);
  white-space: pre-line;
  overflow-wrap: anywhere;

  color: var(--text);
}

.remark {
  color: var(--text-muted);
}

.none {
  font-size: var(--size-200);
  line-height: var(--leading-normal);

  color: var(--text-muted);
}

@media (width < 40rem) {
  .sides {
    grid-template-columns: minmax(0, 1fr);
  }

  .number {
    font-size: var(--size-500);
  }
}
